import { defineStore } from 'pinia'
import { services, getHeader } from '@/assets/js/config.js'
import axios from 'axios'
import { useAuthStore } from '@/stores/authStore'

export const useFintscoreStore = defineStore('fintscoreStore', {
  state: () => ({
    fintscore_price: 36,
    discount_fintscore_price: 36,
    discount: 0,
    ctos_addons: {
      ctos_ccris_price: 1.05,
      ctos_lg_guarantor_price: 1.06,
      ctos_angkasa: 3.10,
      disounct_ctos_ccris_price: 1.05,
      disounct_ctos_lg_guarantor_price: 1.06,
      disounct_ctos_angkasa: 3.10,
    },
    latest_consent: null,
    is_new_esign: false,
    fintscore_reports: [],
    latest_fintscore_report: null
  }),
  actions: {
    resetFintscoreStore() {
      this.latest_consent = null
    },
    async getReportPrices() {
      this.discount = useAuthStore().getLoginInfo.subscription.privileges.scpk_report_discount ?? 0
      try {
        let formData = new FormData()
        formData.append('tables', 'price')
        const response = await axios.post(services.lookup + 'tables', formData, { headers: getHeader() })
        const price = response.data.data.price
        const purchase_ctos_price = price.find((item) => item.price_name === 'purchase_ctos_price')
        if (purchase_ctos_price) {
          this.fintscore_price = parseFloat(purchase_ctos_price.price_amount)
        }
        const ctos_ccris_price = price.find((item) => item.price_name === 'ctos_ccris_price')
        if (ctos_ccris_price) {
          this.ctos_addons.ctos_ccris_price = parseFloat(ctos_ccris_price.price_amount)
        }
        const ctos_lg_guarantor_price = price.find((item) => item.price_name === 'ctos_lg_guarantor_price')
        if (ctos_lg_guarantor_price) {
          this.ctos_addons.ctos_lg_guarantor_price = parseFloat(ctos_lg_guarantor_price.price_amount)
        }
        const ctos_angkasa = price.find((item) => item.price_name === 'ctos_angkasa')
        if (ctos_angkasa) {
          this.ctos_addons.ctos_angkasa = parseFloat(ctos_angkasa.price_amount)
        }

        //AFTER DISCOUNT
        this.discount_fintscore_price = parseFloat(purchase_ctos_price.price_amount)
        this.ctos_addons.disounct_ctos_ccris_price = this.ctos_addons.ctos_ccris_price
        this.ctos_addons.disounct_ctos_lg_guarantor_price = this.ctos_addons.ctos_lg_guarantor_price
        this.ctos_addons.disounct_ctos_angkasa = this.ctos_addons.ctos_angkasa
        if (this.discount > 0) {
          this.discount_fintscore_price = parseFloat(this.fintscore_price) - parseFloat(this.fintscore_price * this.discount / 100);
          this.ctos_addons.disounct_ctos_ccris_price = parseFloat(this.ctos_addons.ctos_ccris_price) - parseFloat(this.ctos_addons.ctos_ccris_price * this.discount / 100);
          this.ctos_addons.disounct_ctos_lg_guarantor_price = parseFloat(this.ctos_addons.ctos_lg_guarantor_price) - parseFloat(this.ctos_addons.ctos_lg_guarantor_price * this.discount / 100);
          this.ctos_addons.disounct_ctos_angkasa = parseFloat(this.ctos_addons.ctos_angkasa) - parseFloat(this.ctos_addons.ctos_angkasa * this.discount / 100);
        }
      } catch (e) {
        _gNotif.cLog('Fintscore Store  (getReportPrices) failed:' + e)
        throw e
      }
    },
    async getAllFintscoreReport(customer_id) {
      try {
        let urlSearchParams = new URLSearchParams()
        urlSearchParams.append('is_full_content', true)
        urlSearchParams.append('pagination[page]', 0)
        urlSearchParams.append('pagination[limit]', 0)
        urlSearchParams.append('pagination[order][message_id]', "DESC")
        urlSearchParams.append('search[fin_cust_id]', customer_id)
        let url = `${services.credit_report}fintscore-reports?${urlSearchParams.toString()}`

        const res = await axios.get(url, { headers: getHeader() })
        this.fintscore_reports = res.data.content
        this.latest_fintscore_report = res.data.content[0]
      } catch (e) {
        _gNotif.cLog('Fintscore Store  (getAllFintscoreReport) failed:' + e)
        throw e
      }
    },
    async generateFintscoreReport(credit_report_id) {
      try {
        let data = {
          fin_credit_report_id: credit_report_id
        }
        const res = await axios.post(services.credit_report + 'fintscore-report', data, { headers: getHeader() })
        this.latest_fintscore_report = res.data
      } catch (e) {
        _gNotif.cLog('Fintscore Store  (generateFintscoreReport) failed:' + e.response.data.message)
        throw e
      }
    },
    async getEsignConsent(customer_id) {
      try {
        this.is_new_esign = false
        const res = await axios.get(services.customer + 'customer/' + customer_id + '/ctos_esign', { headers: getHeader() })
        if (res.data.data.length > 0) {
          await this.getConsentFormDetail(res.data.data[0].cce_uuid)
        }
      } catch (e) {
        this.latest_consent = null
        _gNotif.cLog('Fintscore Store  (getEsignConsent) failed:' + e.response.data.message)
      }
    },
    async getConsentFormDetail(uuid) {
      try {
        const res = await axios.get(services.esign + 'esign/detail?esign_uuid=' + uuid, { headers: getHeader() })
        const consent = res.data
        const expirationDate = new Date(consent.esign_expired_date)
        const currentDate = new Date()
        if (expirationDate > currentDate) {
          this.latest_consent = consent
        }
      } catch (e) {
        this.latest_consent = null
        _gNotif.cLog('Fintscore Store  (getConsentFormDetail) failed:' + e.response.data.message)
      }
    },
    async getNewConsent(customer) {
      if (!customer.contact_no) {
        throw 'Please add the customer contact no.'
      }

      const postData = {
        esign_type: "CONSENT_FORM",
        esign_fullname: customer.name,
        esign_nric: customer.nric,
        esign_mobile_number: customer.contact_no,
        esign_use_otp: 1,
        esign_custom_identifier: "customer_id:" + customer.customer_id
      }

      try {
        const res = await axios.post(services.esign + 'esign/generate', postData, { headers: getHeader() })
        this.latest_consent = res.data
        this.is_new_esign = true
        await this.storeEsignConsent({
          "cce_uuid": res.data.esign_uuid,
          "cce_url": res.data.esign_url,
          "cce_expired_date": res.data.esign_expired_date
        }, customer.customer_id)
      } catch (e) {
        this.latest_consent = null
        throw e
      }
    },
    async storeEsignConsent(data, customer_id) {
      try {
        const res = await axios.post(services.customer + 'customer/' + customer_id + '/ctos_esign', data, { headers: getHeader() })
      } catch (e) {
        _gNotif.cLog('Fintscore Store  (storeEsignConsent) failed:' + error.response.data.message)
        throw e
      }
    }
  }
})